import React, { useState, useEffect } from 'react';
import KernteamLayout from '../../KernteamLayout';
import { host_url } from '../../App';
import BackArrow from '../../BackArrow';
import './KindSaltyScore.css';

function KindSaltyScore() {
  const [zelte, setZelte] = useState([]);
  const [kinder, setKinder] = useState([]);
  const [selectedKindId, setSelectedKindId] = useState('');
  const [selectedZeltId, setSelectedZeltId] = useState('');
  const [saltyScore, setSaltyScore] = useState('');
  const [feedback, setFeedback] = useState({ message: '', type: '' });
  const [isLoading, setIsLoading] = useState(false);
  const [isLoadingZeltsprecher, setIsLoadingZeltsprecher] = useState(false);
  const [isLoadingKinder, setIsLoadingKinder] = useState(true);
  const [zeltsprecherScoreToAdd, setZeltsprecherScoreToAdd] = useState('');

  // Kinder laden
  useEffect(() => {
    const fetchZelte = async () => {
      // setIsLoadingKinder hier nicht direkt setzen, da es sich auf Kinder bezieht
      try {
        const response = await fetch(`${host_url}/zelte`);
        if (!response.ok) throw new Error('Zelte konnten nicht geladen werden.');
        const data = await response.json();
        setZelte(data);
      } catch (error) {
        setFeedback({ message: error.message, type: 'error' });
      }
    };
    fetchZelte();
  }, []);

  // Kinder laden, wenn ein Zelt ausgewählt wird
  useEffect(() => {
    if (selectedZeltId) {
      setIsLoadingKinder(true);
      const fetchKinder = async () => {
        try {
          setKinder([]); // Kinderliste zurücksetzen
          setSelectedKindId(''); // Ausgewähltes Kind zurücksetzen
          setSaltyScore(''); // SaltyScore zurücksetzen
          const response = await fetch(`${host_url}/kinder_formular_daten?zeltId=${selectedZeltId}`);
          if (!response.ok) throw new Error('Kinder für das ausgewählte Zelt konnten nicht geladen werden.');
          const data = await response.json();
          setKinder(data);
        } catch (error) {
          setFeedback({ message: error.message, type: 'error' });
          setKinder([]);
        } finally {
          setIsLoadingKinder(false);
        }
      };
      fetchKinder();
    } else {
      setKinder([]);
      setSelectedKindId('');
      setSaltyScore('');
      setIsLoadingKinder(false); // Sicherstellen, dass Loading-State zurückgesetzt wird
    }
  }, [selectedZeltId]);

  // Salty-Score aktualisieren, wenn ein Kind ausgewählt wird
  useEffect(() => {
    if (selectedKindId) {
      const kind = kinder.find(k => k.KindID.toString() === selectedKindId);
      if (kind && typeof kind.SaltyScore !== 'undefined') { // Achte auf Großschreibung von SaltyScore
        setSaltyScore(kind.SaltyScore.toString());
      } else {
        setSaltyScore(''); // Zurücksetzen, falls Kind nicht gefunden oder kein SaltyScore hat
      }
    } else {
      setSaltyScore(''); // Zurücksetzen, wenn kein Kind ausgewählt ist
    }
  }, [selectedKindId, kinder]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    const score = parseInt(saltyScore, 10);
    if (!selectedKindId || isNaN(score)) {
      setFeedback({ message: 'Bitte wähle ein Kind aus und gib einen gültigen Salty-Score (Zahl) ein.', type: 'error' });
      return;
    }
    setIsLoading(true);
    setFeedback({ message: '', type: '' });
    try {
      const response = await fetch(`${host_url}/kinder/${selectedKindId}/saltyscore`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ saltyScore: score }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Fehler beim Anpassen des Salty-Scores.');
      setFeedback({ message: data.message || 'Salty-Score erfolgreich angepasst!', type: 'success' });
      // Kinderliste im State aktualisieren, um den neuen SaltyScore im Dropdown anzuzeigen
      setKinder(prevKinder => 
        prevKinder.map(kind => 
          kind.KindID.toString() === selectedKindId ? { ...kind, SaltyScore: score } : kind
        )
      );
    } catch (error) {
      setFeedback({ message: error.message, type: 'error' });
    } finally {
      setIsLoading(false);
    }
  };

  const handleZeltsprecherSubmit = async (event) => {
    event.preventDefault();
    const scoreToAdd = parseInt(zeltsprecherScoreToAdd, 10);
    if (isNaN(scoreToAdd) || scoreToAdd === 0) {
      setFeedback({ message: 'Bitte gib eine gültige Zahl (nicht 0) für die Erhöhung des Salty-Scores ein.', type: 'error' });
      return;
    }
    setIsLoadingZeltsprecher(true);
    setFeedback({ message: '', type: '' });
    try {
      const response = await fetch(`${host_url}/zeltsprecher/erhoehe_saltyscore`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ scoreToAdd: scoreToAdd }),
      });
      const data = await response.json();
      if (!response.ok) throw new Error(data.message || 'Fehler beim Erhöhen des Salty-Scores für Zeltsprecher.');
      setFeedback({ message: data.message || 'Salty-Score für alle Zeltsprecher erfolgreich erhöht!', type: 'success' });
      setZeltsprecherScoreToAdd(''); // Formular zurücksetzen
      // Optional: Kinderliste neu laden, um aktualisierte Scores zu sehen, falls ein Zeltsprecher im aktuellen Dropdown ist
      // Dies erfordert, dass der /kinder_formular_daten Endpunkt die aktualisierten Daten liefert oder eine separate Aktualisierung hier.
    } catch (error) {
      setFeedback({ message: error.message, type: 'error' });
    } finally {
      setIsLoadingZeltsprecher(false);
    }
  };

  return (
    <KernteamLayout>
      <div className="container kind-saltyscore-container">
        <BackArrow to="/kinder" />
        <h1 className="section-title kinder">Salty-Score eines Kindes anpassen</h1>
        {feedback.message && <p className={`feedback ${feedback.type}`}>{feedback.message}</p>}
        <form onSubmit={handleSubmit} className="saltyscore-form">
          <div className="form-group">
            <label htmlFor="zelt-select-salty">Zelt</label>
            <div className={`dropdown-wrapper ${selectedZeltId ? 'filled' : ''}`}>
              <select
                id="zelt-select-salty"
                value={selectedZeltId}
                onChange={(e) => setSelectedZeltId(e.target.value)}
                required
              >
                <option value="" disabled>Wähle ein Zelt</option>
                {zelte.map(zelt => <option key={zelt.ZeltID} value={zelt.ZeltID}>{zelt.Zeltname}</option>)}
              </select>
              <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="kind-select-salty">Kind</label>
            <div className={`dropdown-wrapper ${selectedKindId ? 'filled' : ''}`}>
              <select id="kind-select-salty" value={selectedKindId} onChange={(e) => setSelectedKindId(e.target.value)} required disabled={!selectedZeltId || isLoadingKinder || kinder.length === 0}>
                <option value="" disabled>{isLoadingKinder ? "Lade Kinder..." : (selectedZeltId ? "Kind auswählen" : "Bitte zuerst Zelt wählen")}</option>
                {kinder.map(kind => (
                  <option key={kind.KindID} value={kind.KindID}>
                    {kind.Name} {typeof kind.SaltyScore !== 'undefined' ? `(Score: ${kind.SaltyScore})` : ''}
                  </option>
                ))}
              </select>
              <span className="dropdown-plus material-symbols-outlined">keyboard_arrow_down</span>
            </div>
          </div>
          <div className="form-group">
            <label htmlFor="saltyscore-input">Neuer Salty-Score:</label>
            <input
              type="number"
              id="saltyscore-input"
              value={saltyScore}
              onChange={(e) => setSaltyScore(e.target.value)}
              placeholder="z.B. 5"
              required
              disabled={!selectedKindId}
            />
          </div>
          <button type="submit" className="button_primary" disabled={isLoading || !selectedKindId}>
            {isLoading ? 'Speichert...' : 'Salty-Score anpassen'}
          </button>
        </form>
      </div>

      <div className="container kind-saltyscore-container zeltsprecher-bereich">
        <h2 className="section-title kinder">Salty-Score für alle Zeltsprecher erhöhen</h2>
        <form onSubmit={handleZeltsprecherSubmit} className="saltyscore-form">
          <div className="form-group">
            <label htmlFor="zeltsprecher-saltyscore-input">Salty-Score Punkte hinzufügen:</label>
            <input
              type="number"
              id="zeltsprecher-saltyscore-input"
              value={zeltsprecherScoreToAdd}
              onChange={(e) => setZeltsprecherScoreToAdd(e.target.value)}
              placeholder="z.B. 5"
              required
            />
          </div>
          <button type="submit" className="button_primary" disabled={isLoadingZeltsprecher}>
            {isLoadingZeltsprecher ? 'Speichert...' : 'Salty-Score für Zeltsprecher erhöhen'}
          </button>
        </form>
      </div>
    </KernteamLayout>
  );
}

export default KindSaltyScore;
